import { Injectable } from '@angular/core';

import { AppSettingsService } from './app-settings.service';

@Injectable()
export class MenuService {
    private DashboardAdmin = { name: 'Dashboard', route: this.appSettingsService.AdminDashboardPath, iconName: '#dashboard', isMenuItem: true };
    private Users = { name: 'Users', route: this.appSettingsService.UsersPath, iconName: '#user', isMenuItem: true };
    private Campaigns = { name: 'Campaigns', route: this.appSettingsService.Campaigns, iconName: '#campaigns', isMenuItem: true };
    private BrandLogos = { name: 'Brand Logos', route: this.appSettingsService.BrandLogos, iconName: '#grid_icon_nav', isMenuItem: true }
    private BrandPreId = { name: 'Brand Pre-Id', route: this.appSettingsService.BrandPreId, iconName: '#grid_icon_nav', isMenuItem: true }
    private Creative = { name: 'Creatives', route: this.appSettingsService.Creative, iconName: '#grid_icon_nav', isMenuItem: true }
    private Asset = { name: 'Assets', route: this.appSettingsService.Asset, iconName: '#grid_icon_nav', isMenuItem: true }
    private Content = { name: 'Content', route: this.appSettingsService.Content, iconName: '#content_icon', hasChildren: true, subItems: [this.Campaigns, this.Creative, this.Asset, this.BrandLogos, this.BrandPreId], isMenuItem: true };
    private CampaignDetails = { route: this.appSettingsService.CampaignDetails, isMenuItem: false };
    private Mediation = { name: 'Mediation', route: this.appSettingsService.Mediation, iconName: '#med', isMenuItem: true };
    private Payment = { name: 'Payments', route: this.appSettingsService.Payment, iconName: '#payments', isMenuItem: true };
    private Providers = { name: 'Providers', route: this.appSettingsService.Providers, iconName: '#providers', isMenuItem: true };
    private DemandSources = { name: 'Demand Sources', route: this.appSettingsService.DemandSources, iconName: '#content', hasChildren: true, subItems: [this.Providers], isMenuItem: true };
    private Publishers = { name: 'Publishers', route: this.appSettingsService.Publishers, iconName: '#publishers2', isMenuItem: true };
    private Settings = { name: 'Settings', route: this.appSettingsService.Settings, iconName: '#settings', hasChildren: true, subItems: [this.Publishers], isMenuItem: true };
    private PublisherDashboard = { name: 'Dashboard', route: this.appSettingsService.PublisherDashboardPath, iconName: '#dashboard', isMenuItem: true };
    private Reports = { name: 'Reports', route: this.appSettingsService.ReportsPath, iconName: '#reports', isMenuItem: true };

    private SambaAdminItems: Array<any> = [this.DashboardAdmin, this.Users, this.DemandSources, this.Content, this.CampaignDetails, this.Settings, this.Mediation, this.Payment, this.Reports];
    private PublisherAdminItems: Array<any> = [this.PublisherDashboard, this.CampaignDetails, {mainMenuItem:this.Content, subItems:[this.Campaigns, this.Asset] }, this.Settings, this.Payment, this.Reports];
    private ProviderAdminItems: Array<any> = [];

    constructor(private appSettingsService: AppSettingsService) {
    }

    public getMenuItems(userType: number): Array<any> {
        return this.getItems(userType, false);
    }

    public getDefaultPageUrl(userType: number): string {
        let routes = this.getItems(userType, false);
        if (routes && routes.length > 0)
            return routes[0].route;
        return this.appSettingsService.UnauthorizedPath;
    }

    private getItems(userType: number, allItems: boolean): Array<any> {
        let items = Array<any>();
        switch (userType) {
            case 1: {
                for (let adminItem of this.SambaAdminItems)
                    if (allItems || adminItem.isMenuItem)
                        items.push(adminItem);
                return items;
            }
            case 2: {
                for (let adminItem of this.PublisherAdminItems)
                    if (allItems || adminItem.isMenuItem || adminItem.mainMenuItem && adminItem.mainMenuItem.isMenuItem)
                    {
                        if (adminItem.mainMenuItem)
                        {
                            let item = adminItem.mainMenuItem;
                            let subItems = adminItem.subItems;
                            item.subItems = subItems;
                            items.push(item);
                        }
                        else
                        items.push(adminItem);
                        
                    }
                return items;
            }
            case 3: {
                for (let adminItem of this.ProviderAdminItems)
                    if (allItems || adminItem.isMenuItem)
                        items.push(adminItem);
                return items;
            }
        }
    }

    public hasRights(userType: number, route: string): boolean {
        let items = this.getItems(userType, true);
        for (let item of items) {
            if (route && (item.route === route || (route.includes('/') && route.includes(item.route))))
                return true;
            if (item.hasChildren && item.subItems) {
                for (let subItem of item.subItems) {
                    if (route && (subItem.route === route || (route.includes('/') && route.includes(subItem.route))))
                        return true;
                }
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/menu.service.ts